import template from "./restore_route_assignments.html";
import controller from "./restore_route_assignments.controller";
import "./restore_route_assignments.scss";

let branchManagementRestoreRouteAssignmentsComponent = {
    restrict: "E",
    bindings: {},
    template,
    controller
}

export default branchManagementRestoreRouteAssignmentsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/restore_route_assignments/restore_route_assignments.component.js